import { MAP_ELEMENT } from "../../contexts/WorldMapContext/constants";
import { api } from "../api/callApi";
import { urlServer } from "../api/v1";
import { IMaterial, IPois } from "../varibles/interface";

const urlBase = urlServer + '/poi'

interface ICreatePoi {
    name: string
    type: MAP_ELEMENT
    position: {
        latitude: number,
        longitude: number
    },
    capabilities?: any[],
    work_time: number | '-' | string,
    inventory?: IMaterial[]
}

interface IUpdatePoi extends ICreatePoi {
    id: string

}

interface IGetWeatherOfPoi {
    id: string,
    type: MAP_ELEMENT
}

interface IUpdateInventory {
    id: string,
    type: MAP_ELEMENT
    inventory: IMaterial[]
}

export const PoiService = {
    gets: () => api.get<IPois[]>(urlBase + 's'),
    create: (params: ICreatePoi) => api.post(urlBase, params),
    update: (params: IUpdatePoi) => api.put(urlBase, params),
    delete: (id: string) => api.deleteBody(urlBase, { id }),
    weather: (params: IGetWeatherOfPoi) => api.put<{ weather: any, typical_condition: number }>(urlBase + '/weather', params),
    inventory: (params: IUpdateInventory) => api.put(urlBase + '/inventory', params),
}